import { render, staticRenderFns } from "./mmse.vue?vue&type=template&id=225993b3&scoped=true"
import script from "./mmse.vue?vue&type=script&lang=js"
export * from "./mmse.vue?vue&type=script&lang=js"
import style0 from "./mmse.vue?vue&type=style&index=0&id=225993b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225993b3",
  null
  
)

export default component.exports